import { ContentSection } from '@components/ContentSection';
import { Layout } from '@components/Layout';
import { PageHeader } from '@components/PageHeader';
import Header from '@components/_OldDesign/header';
import { ReactElement } from 'react';
import { NextPageWithLayout } from './_app';

const CookiePolicyPage: NextPageWithLayout = () => {
  return (
    <>
      <Header content={{
          title: 'Cookie Policy - นโยบายการใช้งานคุกกี้ของ CODIUM',
          content: 'เรียนรู้เกี่ยวกับนโยบายการใช้งานคุกกี้ของ CODIUM เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์การใช้งานและบริการของคุณบนเว็บไซต์ของเรา',
          image: null,
        }}/>
      <PageHeader
        topic="นโยบายคุกกี้"
        detail="เว็บไซต์ของบริษัท โคเดียม จำกัด ต่อไปนี้เรียก ว่า (“บริษัทฯ”)
        มีการใช้งานคุกกี้ (Cookie) (“คุกกี้”)
        เพื่อติดตามจำนวนผู้เยี่ยมชมเว็บไซต์และหน้าเว็บไซต์ ที่เยี่ยมชมรวมถึง
        เพื่อวิเคราะห์ ปรับปรุง และพัฒนาเว็บไซต์ของบริษัทฯ เพื่อ
        ให้ผู้เยี่ยมชมเว็บไซต์ได้รับประโยชน์สูงสุด ในการนี้ บริษัทฯ
        จึงขอแจ้งให้ ท่านทราบถึงรายละเอียดและการทำงานของ คุกกี้ ดังต่อไปนี้"
        backgroundImage="/images/cookie-policy/cookie-policy-page-header.png"
      />

      <div className="relative w-screen h-fit py-16">
        <ContentSection topic="คุกกี้คืออะไร?">
          <p>
            คุกกี้ คือ ไฟล์ขนาดเล็กที่จะถูกดาวน์โหลดและจัดเก็บไว้
            ในอุปกรณ์คอมพิวเตอร์ที่เชื่อมต่อกับอินเทอร์เน็ตของท่าน เช่น
            คอมพิวเตอร์ แท็บเล็ต โทรศัพท์มือถือ หรืออุปกรณ์อิเล็กทรอนิกส์
            ที่จะไม่ก่อให้เกิดอันตรายต่ออุปกรณ์คอมพิวเตอร์ของท่านแต่อย่างใด
            ในการนี้
            คุกกี้จะทำให้เว็บไซต์สามารถจดจำความชื่นชอบและประวัติการใช้งานของท่าน
            และคุกกี้จะนำข้อมูลดังกล่าวที่บันทึกเอาไว้ในคุกกี้มาใช้เมื่อท่านเยี่ยมชมเว็บไซต์
            หรือนำมาแสดงผลเพื่อการให้บริการตามที่ท่านร้องขอเป็นครั้งคราว
            คุกกี้จะบอกให้บริษัทฯ
            ทราบว่าท่านเข้าใช้งานส่วนใดของเว็บไซต์ของบริษัทฯ เพื่อที่บริษัทฯ
            จะสามารถให้บริการข้อมูลได้ตรงกับความต้องการของท่านได้ นอกจากนี้
            คุกกี้จะช่วยให้ท่านเข้าถึงข้อมูลเฉพาะเจาะจงที่ท่านร้องขอโดยอัตโนมัติ
            เว้นแต่กรณีที่ท่านได้ลบคุกกี้ออกจากระบบคอมพิวเตอร์ของท่าน
          </p>
        </ContentSection>

        <ContentSection topic="ข้อมูลที่เก็บรวบรวมโดยคุกกี้" className="mt-10">
          <p>
            ท่านตกลงยินยอมและรับทราบว่าคุกกี้ในเว็บไซต์ ของบริษัทฯ
            จะทำการเก็บรวบรวมข้อมูลและข้อมูลส่วนบุคคลของท่านดังต่อไปนี้โดยอัตโนมัติ
          </p>

          <ul className="list-disc list-outside pl-4 my-5">
            <li>
              ข้อมูลจราจรคอมพิวเตอร์ (Log File) เช่น หมายเลขไอพีแอดเดรส (IP
              Address) ของท่าน และวันที่และเวลาที่ท่านเยี่ยมชมเว็บไซต์ของบริษัทฯ
            </li>
            <li>
              รายละเอียดและพฤติกรรมการใช้งานเว็บไซต์ของบริษัทฯ เช่น
              หน้าเว็บไซต์ที่ท่านเยี่ยมชม
              และหน้าเว็บไซต์ที่ท่านเยี่ยมชมเป็นลำดับสุดท้ายก่อนที่ท่านจะออกจากเว็บไซต์ของบริษัทฯ
              รวมถึงเนื้อหาบนหน้าเว็บไซต์ที่เยี่ยมชมและระยะเวลาที่ใช้ในการเยี่ยมชม
            </li>
            <li>
              บัญชีผู้ใช้และรหัสผ่าน (Username and Password) ของท่าน
              ในกรณีที่ท่านเลือกให้เว็บไซต์ “จดจำรหัสผ่าน” ของท่าน
            </li>
            <li>
              ประเภทของเว็บเบราว์เซอร์ (Browser) ที่ใช้ในการเยี่ยมชมเว็บไซต์
            </li>
            <li>
              โดเมนเนมของเว็บไซต์ที่เชื่อมโยงท่านเข้าสู่เว็บไซต์ของบริษัทฯ{' '}
            </li>
            <li>ตำแหน่ง (Location) ของท่าน</li>
          </ul>

          <p>
            บริษัทฯ จะนำหมายเลขไอพีแอดเดรส (IP Address) หรือข้อมูลที่บริษัทฯ
            เก็บรวบรวมข้างต้นไปใช้เพื่อระบุตัวตนของท่าน เพื่อการปฏิบัติตามกฎหมาย
            เพื่อปกป้องผลประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ
            และเพื่อวัตถุประสงค์ที่กำหนดในประกาศความเป็นส่วนตัว (Privacy Notice)
            ของบริษัทฯ เท่านั้น ทั้งนี้
            ท่านสามารถศึกษารายละเอียดของประกาศดังกล่าวได้ที่
            “ประกาศความเป็นส่วนตัว”
          </p>
        </ContentSection>

        <ContentSection topic="ประเภทคุกกี้ที่บริษัทฯ ใช้งาน" className="mt-10">
          <p>คุกกี้ที่บริษัทฯ ใช้ในเว็บไซต์ของบริษัทฯ มีดังต่อไปนี้</p>
          <ol className=" list-decimal list-outside pl-4 mt-5">
            <li>
              คุกกี้ประเภทที่จำเป็นต่อการทำงานของเว็บไซต์ (Strictly necessary
              cookies): คือ
              คุกกี้ที่จำเป็นและมีความสำคัญต่อการทำงานของเว็บไซต์ของบริษัทฯ
              ที่ทำให้เว็บไซต์ของบริษัทฯ สามารถทำงานได้เป็นปกติ
            </li>
            <li>
              คุกกี้เพื่อการวิเคราะห์ข้อมูล (Analytic cookies): คือ
              คุกกี้ที่บริษัทฯ ใช้เพื่อติดตามข้อมูลทางสถิติ เช่น
              จำนวนผู้เยี่ยมชมเว็บไซต์และหน้าเว็บไซต์ที่เยี่ยมชม
              รวมถึงลักษณะและพฤติกรรมของผู้ใช้บริการที่ใช้งานเว็บไซต์ของบริษัทฯ
              สำหรับวิเคราะห์และประมวลผลเพื่อพัฒนาและปรับปรุงเว็บไซต์ของบริษัทฯ
            </li>
            <li>
              คุกกี้ทางการตลาด (Marketing cookies):
              คุกกี้ที่ถูกใช้ในการติดตามผู้เข้าเยี่ยมชมเว็บไซต์
              โดยวัตถุประสงค์ของคุกกี้ประเภทนี้เพื่อประโยชน์ในการโฆษณาและการดำเนินการด้านการตลาด
            </li>
          </ol>
        </ContentSection>

        <ContentSection topic="การลบและ/หรือการปิดกั้นคุกกี้" className="mt-10">
          <p>
            การที่ท่านเยี่ยมชมและใช้บริการเว็บไซต์ของบริษัทฯ
            ถือว่าท่านได้ตกลงและให้ความยินยอมสำหรับการใช้คุกกี้ของ บริษัทฯ
            ตามที่ระบุในนโยบายเกี่ยวกับการใช้งานคุกกี้นี้ ทั้งนี้
            หากท่านประสงค์ที่จะเพิกถอนความยินยอมสำหรับการใช้คุกกี้ดังกล่าว
            ท่านสามารถลบและ/หรือปิดกั้นคุกกี้ในเว็บบราว์เซอร์ (Browser)
            ในอุปกรณ์คอมพิวเตอร์ของท่าน ดังนี้
          </p>
          <ul className="list-disc list-outside pl-4 my-5">
            <li>Chrome</li>
            <li>Firefox</li>
            <li>Microsoft Edge</li>
            <li>Internet Explorer</li>
            <li>Safari for ios</li>
            <li>Chrome for android</li>
            <li>Chrome for ios</li>
          </ul>
          <p>
            อนึ่ง บริษัทฯ ขอเรียนว่าการจำกัดการใช้งานคุกกี้
            อาจส่งผลให้ท่านไม่สามารถเข้าถึงเว็บไซต์ของบริษัทฯ ได้ครบทุกส่วน
          </p>
        </ContentSection>

        <ContentSection
          topic="การแก้ไขนโยบายเกี่ยวกับการใช้งานคุกกี้"
          className="mt-10"
        >
          <p>
            บริษัทฯ
            สงวนสิทธิที่จะปรับปรุงหรือแก้ไขนโยบายเกี่ยวกับการใช้งานคุกกี้นี้ตามที่บริษัทฯ
            เห็นสมควร ท่านจึงควรตรวจสอบนโยบายนี้เป็นระยะ ๆ
            เพื่อให้ทราบถึงการปรับปรุงและการแก้ไขดังกล่าวเพื่อประโยชน์ของท่านเอง
          </p>
        </ContentSection>

        <ContentSection topic="ติดต่อสอบถาม" className="mt-10">
          <p>
            หากท่านมีข้อสงสัยเกี่ยวกับการใช้งานคุกกี้หรือนโยบายเกี่ยวกับการใช้งานคุกกี้ของบริษัทฯ
            ท่านสามารถติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทฯ (“DPO”)
            / คณะทำงานกำกับดูแลการคุ้มครองข้อมูลส่วนบุคคล ได้ที่
          </p>

          <p className="mt-5">
            ที่อยู่: 865 ชั้นที่ 7 ถนนพระราม 1 แขวงวังใหม่ เขตปทุมวัน
            กรุงเทพมหานคร 10330
            <br />
            อีเมล: contact@codium.co
          </p>
        </ContentSection>

        <p className="Container text-neutral-600 text-p3Regular mt-10">
          อัปเดตล่าสุด 13 กันยายน 2565
        </p>
      </div>
    </>
  );
};

CookiePolicyPage.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default CookiePolicyPage;
